export enum AudioBitrateEnum {
  Kbps32 = 32, // Very low quality, often used for speech or very low bitrate audio streams.
  Kbps64 = 64, // Common for speech (like podcasts, voice streams).
  Kbps128 = 128, // Standard quality for MP3, AAC, or Opus, commonly used in streaming for general audio and even music in some cases.
  Kbps192 = 192, // A bit higher than 128k, offering better audio quality, especially for music.
  Kbps256 = 256, // High-quality audio for most streaming scenarios, provides good balance of quality and file size.
  Kbps320 = 320, // High quality, especially for MP3 or AAC, often used for premium music streaming or higher-fidelity content.
  Kbps512 = 512, // High-quality audio streaming, often used for content like high-quality internet radio or live broadcasts.
  Kbps768 = 768, // Very high quality for live broadcasts or professional-grade streaming.
  Kbps1024 = 1024, // 1 Mbps – Extremely high-quality audio stream, suitable for specialized applications, like professional broadcasting.
}

export type AudioBitrate =
  | AudioBitrateEnum.Kbps32
  | AudioBitrateEnum.Kbps64
  | AudioBitrateEnum.Kbps128
  | AudioBitrateEnum.Kbps192
  | AudioBitrateEnum.Kbps256
  | AudioBitrateEnum.Kbps320
  | AudioBitrateEnum.Kbps512
  | AudioBitrateEnum.Kbps768
  | AudioBitrateEnum.Kbps1024;
